import { render, staticRenderFns } from "./EditClassroomPage.vue?vue&type=template&id=0a2b3a90&scoped=true"
import script from "./EditClassroomPage.vue?vue&type=script&lang=js"
export * from "./EditClassroomPage.vue?vue&type=script&lang=js"
import style0 from "./EditClassroomPage.vue?vue&type=style&index=0&id=0a2b3a90&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b3a90",
  null
  
)

export default component.exports